export default __webpack_public_path__ + "static/media/featured-item-20.492304ed.png";